import { useFormContext } from "react-hook-form";
import { UpdatePasswordFormValues } from "./types";
import { Stack, TextField } from "@towersystems/roam-common-native";

export interface UpdatePasswordFormProps {
  onSubmit: (values: UpdatePasswordFormValues) => unknown | Promise<unknown>;
}

export const UpdatePasswordForm = ({ onSubmit }: UpdatePasswordFormProps) => {
  const { register, reset, handleSubmit, formState } =
    useFormContext<UpdatePasswordFormValues>();

  const { errors } = formState;

  return (
    <>
      <Stack vertical>
        <TextField
          secureTextEntry={true}
          label="Old Password"
          {...register("oldPassword")}
          validationMessage={errors.oldPassword?.message}
        />
        <TextField
          secureTextEntry={true}
          label="New Password"
          {...register("newPassword")}
          validationMessage={errors.newPassword?.message}
        />
        <TextField
          secureTextEntry={true}
          label="Confirm New Password"
          {...register("confirmPassword")}
          validationMessage={errors.confirmPassword?.message}
        />
      </Stack>
    </>
  );
};
